function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import * as React from 'react';
const {
  useCallback,
  useEffect,
  useRef,
  useReducer
} = React;
const reducer = (state, action) => {
  switch (action.type) {
    case 'loading':
      return _objectSpread(_objectSpread({}, state), {}, {
        status: 'loading'
      });
    case 'completed':
      const {
        results
      } = action.payload;
      return _objectSpread(_objectSpread({}, state), {}, {
        status: 'completed',
        results
      });
    case 'error':
      return _objectSpread(_objectSpread({}, state), {}, {
        status: 'error',
        results: []
      });
    case 'query':
      const {
        queryString
      } = action.payload;
      return _objectSpread(_objectSpread({}, state), {}, {
        queryString
      });
    default:
      return state;
  }
};
const useSearch = query => {
  const canHandle = useRef(false);
  const initialState = {
    queryString: '',
    results: [],
    status: 'initial'
  };

  // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
  const [state, dispatch] = useReducer(reducer, initialState);
  const onChangeQuery = useCallback(value => {
    // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
    dispatch({
      type: 'query',
      payload: {
        queryString: value
      }
    });
  }, []);
  const {
    queryString,
    results,
    status
  } = state;
  useEffect(() => {
    canHandle.current = true;
    // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
    dispatch({
      type: 'loading'
    });
    query(queryString).then(results => {
      if (canHandle.current) {
        // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
        dispatch({
          type: 'completed',
          payload: {
            results
          }
        });
      }
    }, reason => {
      if (canHandle.current) {
        // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
        dispatch({
          type: 'error'
        });
      }
    });
    return () => {
      canHandle.current = false;
    };
  }, [query, queryString]);
  return {
    onChangeQuery,
    queryString,
    results,
    status
  };
};
export default useSearch;